import get from 'lodash/get'

import main from 'Theme/Main'

export const getThemeField = key => props => `${get(props.theme, key)}`

export default {
  main
}
